import { useAuth } from '@/hooks/useAuth';

export function ImpersonationBanner() {
  const { isImpersonating, user, endImpersonation } = useAuth();

  if (!isImpersonating) return null;

  return (
    <div className="flex h-12 items-center justify-center gap-3 bg-[var(--ma-warning-on-light)] px-4 text-sm text-white">
      <span>
        ⚠️ Sessão de suporte ativa: você está navegando como{' '}
        <strong>{user?.name}</strong> — <strong>{user?.workshopName}</strong>.
        Ações são logadas.
      </span>
      <button
        type="button"
        onClick={endImpersonation}
        className="rounded border border-white/30 px-3 py-1 text-xs font-medium hover:bg-white/10"
      >
        Encerrar sessão
      </button>
    </div>
  );
}
